import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse-bndes.model';

@Injectable({
  providedIn: 'root'
})
export class TarefasOperacaoService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/operacao';
  }

  public importarLiberacoes(): Observable<any> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/importacao/liberacao/repasse`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public importarOperacaoCreditoLivre(dto): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/importacao/credito-livre`, dto, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public importarOperacaoRepasse(dto): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/importacao/repasse`, dto, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarEstadoOperacao(idOperacao: number, idEstado: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-estado/operacao/${idOperacao}/estado/${idEstado}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarFatorK(idOperacao: number, fatorK: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-fator-k/operacao/${idOperacao}/${fatorK}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarEstadoAditivo(idAditivo: number, idEstadoAditivo: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-estado/aditivo/${idAditivo}/estado/${idEstadoAditivo}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

    public alterarEstadoLiberacao(idOperacao: number, numeroLiberacao: number, idEstadoLiberacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-estado/operacao/${idOperacao}/liberacao/${numeroLiberacao}/estado/${idEstadoLiberacao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public criarScrValido(idOperacao: number, dataPrimeiraParcelaInadimplente: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar-scr-valido/operacao/${idOperacao}/data-primeira-parcela-inadimplente/${dataPrimeiraParcelaInadimplente}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public criarScrInvalido(idOperacao: number, dataPrimeiraParcelaInadimplente: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar-scr-invalido/operacao/${idOperacao}/data-primeira-parcela-inadimplente/${dataPrimeiraParcelaInadimplente}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public efetivarContratacaoGarantiaCorte(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/rodar-processamento-corte-contratacao`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }
  public deslocarOperacaoNoTempo(idOperacao:number , qtdMesesDeslocamento:number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/deslocar-operacao-no-tempo/operacao/${idOperacao}/qtdMesesDeslocamento/${qtdMesesDeslocamento}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }
  public criarOperacaoDeRepasse(operacao:OperacaoRepasseBndes): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar-operacao/repasse`, operacao, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }
  public criarOperacaoDeRepassePorJson(conteudoJson: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar-operacao/repasse/json `, conteudoJson,options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }
}
